import { FileUpload } from "#components/file_upload";
import { postMultipart, get_image_url } from "#api";

function AnimalPictures({ animal }) {
  const handleFileUpload = async (files) => {
    const formData = new FormData();
    const fileArr = Array.from(files);
    fileArr.forEach((x) => {
      formData.append("file", x, x.name);
    });
    var response = await postMultipart(
      `/file/animal/${animal.animalId}`,
      formData,
    );
    if (response) {
    }
  };
  return (
    <div className="p-4">
      <div className="text-lg font-semibold pb-2">Pictures</div>
      <div className="w-full max-w-4xl mx-auto min-h-96 border border-dashed bg-white dark:bg-black border-neutral-200 dark:border-neutral-800 rounded-lg">
        <FileUpload onChange={handleFileUpload} />
        <ImageGrid images={animal.images} />
      </div>
    </div>
  );
}
function ImageGrid({ images }) {
  return (
    <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 p-4 place-items-center">
      {images?.map((x) => (
        <img
          key={x}
          className="border border-neutral-200 dark:border-neutral-800 shadow-md hover:shadow-lg rounded-md p-2"
          src={get_image_url(x)}
          alt="..."
        />
      ))}
    </div>
  );
}

export default AnimalPictures;
